import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";
import { analytics } from '../firebase/firebase'; // adjust if your path differs
import { logEvent } from 'firebase/analytics'; // basic GA4 event logging

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });

    // Log scroll event
    logEvent(analytics, 'footer_scroll_link_clicked_FacelessVideo', {
      sectionId,
    });
  }
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleFooterLinkClick = (linkName) => {
    logEvent(analytics, 'footer_link_clicked_FacelessVideo', {
      link_name: linkName,
    });
  };

  return (
    <footer>
      <section className="footer_top" id="Footer">
        <div className="form_footer">
          <h2 className="footer_headings">Generator.video</h2>
          <p className="footer_subheadings">
            Quickly generate faceless videos with customizable prompts, adjust aspect ratios,
            select music, choose fonts, and set the perfect duration. Create professional-quality
            content with ease!
          </p>
        </div>

        <div className="product_footer">
          <h3 className="footer_headings">PRODUCT</h3>
          <p className="footer_subheadings" onClick={() => scrollToSection('HowItWorks')}>How it works</p>
          <p className="footer_subheadings" onClick={() => scrollToSection('Features')}>Features</p>
          <p className="footer_subheadings" onClick={() => scrollToSection('Pricing')}>Pricing</p>
        </div>

        <div className="product_footer">
          <h3 className="footer_headings">SUPPORT</h3>
          <p
            className="footer_subheadings"
            onClick={() => scrollToSection('FAQ')}
          >
            FAQ
          </p>
          <Link
            to="/blog/"
            className="footer_subheadings"
            onClick={() => handleFooterLinkClick('Blog')}
          >
            Blog
          </Link>
          <Link
            to="/privacy"
            className="footer_subheadings"
            onClick={() => handleFooterLinkClick('Privacy Policy')}
          >
            Privacy Policy
          </Link>
          <Link
            to="/refundpolicy"
            className="footer_subheadings"
            onClick={() => handleFooterLinkClick('Refund Policy')}
          >
            Refund Policy
          </Link>
          <Link
            to="/terms&condition"
            className="footer_subheadings"
            onClick={() => handleFooterLinkClick('Terms & Conditions')}
          >
            Terms & Conditions
          </Link>
        </div>

        <div className="contact_footer">
          <h3 className="footer_headings">CONTACT</h3>
          <p className="footer_subheadings">speedapps1010@gmail.com</p>
          <p className="footer_subheadings">+91 8176851179</p>
        </div>
      </section>
      <div
  style={{
    maxWidth: "900px",
    margin: "20px auto",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
    padding: "0 20px"
  }}
>
  Generator.video does not support the creation of deepfake, face-swapped,
  or impersonation content involving real individuals. Users must not use
  the platform to create deceptive synthetic media or violate the rights of
  others.
</div>

      <section className="footer_terms">
        <Link
          to="/terms&condition"
          style={{ textDecoration: 'none', color: 'inherit' }}
          onClick={() => handleFooterLinkClick('Terms and Conditions')}
        >
          <p>Terms and Conditions</p>
        </Link>
        <p>© {currentYear} - Generator.video | All rights reserved</p>
      </section>
    </footer>
  );
};

export default Footer;
